import { Pipe, PipeTransform } from '@angular/core'
import { formatDate } from '@angular/common'

@Pipe({
    name: 'displayContractBulkActionState',
    standalone: false
})
export class DisplayContractBulkActionStatePipe implements PipeTransform {
    transform(bulkOperation: any): string {
        switch (bulkOperation.state) {
            case 'CREATED':
                return 'zadáno ' + formatDate(bulkOperation.timeCreated, 'dd. MM. yyyy H:mm:ss', 'cs')
            case 'STARTED':
                return 'spuštěno ' + formatDate(bulkOperation.timeStarted, 'dd. MM. yyyy H:mm:ss', 'cs')
            case 'DONE':
                return 'dokončeno ' + formatDate(bulkOperation.timeDone, 'dd. MM. yyyy H:mm:ss', 'cs')
            default:
                return ''
        }
    }
}
